import TabsInmueble from "./Tabs";

export default function AgregarInmueble() {
    return (
        <>
            <TabsInmueble/>
        </>
    )
}